<template>
  <section id="hero" class="hero">
    <div class="hero-bg">
      <div class="grid-overlay"></div>
      <div class="orb orb-1"></div>
      <div class="orb orb-2"></div>
      <div class="orb orb-3"></div>
      <div class="particles">
        <span v-for="i in 20" :key="i" class="particle" :style="particleStyle()"></span>
      </div>
    </div>

    <div class="container hero-content">
      <div class="hero-left animate__animated animate__fadeInLeft">
        <div class="hero-badge">
          <i class="el-icon-cpu"></i>
          <span>{{ $t('hero.badge') }}</span>
        </div>
        <h1 class="hero-title">
          {{ $t('hero.titleLine1') }}<br />
          <span class="gradient-text">{{ $t('hero.titleHighlight') }}</span>
        </h1>
        <p class="hero-desc">
          {{ $t('hero.desc') }}
        </p>
        <div class="hero-actions">
          <el-button type="primary" size="large" class="btn-primary" @click="scrollTo('business')">
            {{ $t('hero.primaryCta') }}
            <i class="el-icon-arrow-right"></i>
          </el-button>
          <el-button size="large" class="btn-outline" @click="scrollTo('about')">
            {{ $t('hero.secondaryCta') }}
          </el-button>
        </div>
      </div>

      <div class="hero-right animate__animated animate__fadeInRight">
        <div class="hero-card-stack">
          <div class="floating-card card-main">
            <div class="card-icon ai-icon"><i class="el-icon-cpu"></i></div>
            <div class="card-body">
              <h3>{{ $t('hero.aiAuditTitle') }}</h3>
              <p>{{ $t('hero.aiAuditDesc') }}</p>
              <div class="card-progress">
                <div class="progress-label">
                  <span>{{ $t('hero.accuracy') }}</span>
                  <span>95%</span>
                </div>
                <el-progress :percentage="95" color="#6c5ce7" :show-text="false" :stroke-width="6"></el-progress>
              </div>
            </div>
          </div>

          <div class="floating-card card-secondary">
            <div class="card-icon med-icon"><i class="el-icon-first-aid-kit"></i></div>
            <div class="card-body">
              <h3>{{ $t('hero.twinTitle') }}</h3>
              <p>{{ $t('hero.twinDesc') }}</p>
            </div>
          </div>

          <div class="floating-card card-tertiary">
            <div class="card-icon check-icon"><i class="el-icon-finished"></i></div>
            <div class="card-body">
              <h3>PBRTQC</h3>
              <p>{{ $t('hero.pbrtqcDesc') }}</p>
            </div>
          </div>

          <div class="pulse-ring"></div>
        </div>
      </div>
    </div>

    <div class="scroll-hint" @click="scrollTo('about')">
      <span>{{ $t('hero.scrollHint') }}</span>
      <i class="el-icon-arrow-down bounce"></i>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroSection',
  methods: {
    scrollTo(id) {
      const el = document.getElementById(id)
      if (el) el.scrollIntoView({ behavior: 'smooth' })
    },
    particleStyle() {
      const rand = (min, max) => Math.random() * (max - min) + min
      return {
        left: rand(0, 100) + '%',
        top: rand(0, 100) + '%',
        width: rand(2, 6) + 'px',
        height: rand(2, 6) + 'px',
        animationDelay: rand(0, 8) + 's',
        animationDuration: rand(4, 12) + 's'
      }
    }
  }
}
</script>

<style lang="less" scoped>
.hero { min-height: 100vh; position: relative; display: flex; align-items: center; overflow: hidden; background: #050d1a; }
.hero-bg { position: absolute; inset: 0; background: linear-gradient(135deg, #050d1a 0%, #0a1628 45%, #0d1f3c 100%); }
.grid-overlay { position: absolute; inset: 0; background-image: linear-gradient(rgba(0,201,167,.04) 1px, transparent 1px), linear-gradient(90deg, rgba(0,201,167,.04) 1px, transparent 1px); background-size: 60px 60px; }
.orb { position: absolute; border-radius: 50%; filter: blur(80px); animation: orbFloat 8s ease-in-out infinite; }
.orb-1 { width: 600px; height: 600px; top: -200px; right: -100px; background: radial-gradient(circle, rgba(10,92,138,.3), transparent 70%); }
.orb-2 { width: 400px; height: 400px; bottom: -100px; left: -50px; background: radial-gradient(circle, rgba(0,201,167,.2), transparent 70%); }
.orb-3 { width: 300px; height: 300px; top: 40%; left: 35%; background: radial-gradient(circle, rgba(108,92,231,.15), transparent 70%); }
.particles { position: absolute; inset: 0; }
.particle { position: absolute; border-radius: 50%; background: rgba(0,201,167,.6); animation: particleFly linear infinite; }
.hero-content { position: relative; z-index: 2; display: flex; align-items: center; gap: 80px; width: 100%; padding-top: 100px; padding-bottom: 60px; }
.hero-left { flex: 1; min-width: 0; }
.hero-badge { display: inline-flex; align-items: center; gap: 8px; background: rgba(0,201,167,.12); border: 1px solid rgba(0,201,167,.3); border-radius: 30px; padding: 6px 16px; margin-bottom: 28px; color: #00c9a7; font-size: 13px; }
.hero-title { font-size: 58px; font-weight: 800; color: #fff; line-height: 1.2; margin-bottom: 24px; }
.hero-desc { font-size: 16px; color: rgba(255,255,255,.68); line-height: 1.9; max-width: 560px; margin-bottom: 36px; }
.hero-actions { display: flex; gap: 16px; margin-bottom: 50px; flex-wrap: wrap; }
.btn-primary { background: linear-gradient(135deg, #0a5c8a, #00c9a7) !important; border: none !important; border-radius: 30px !important; padding: 0 28px !important; height: 48px !important; font-weight: 600 !important; }
.btn-outline { background: transparent !important; border: 1px solid rgba(255,255,255,.3) !important; color: rgba(255,255,255,.85) !important; border-radius: 30px !important; padding: 0 28px !important; height: 48px !important; }
.hero-right { flex: 0 0 440px; position: relative; }
.hero-card-stack { position: relative; height: 380px; }
.floating-card { position: absolute; background: rgba(255,255,255,.06); backdrop-filter: blur(20px); border: 1px solid rgba(255,255,255,.12); border-radius: 20px; padding: 24px; display: flex; align-items: flex-start; gap: 16px; box-shadow: 0 20px 60px rgba(0,0,0,.3); }
.card-main { width: 320px; top: 40px; left: 0; flex-direction: column; animation: cardFloat1 6s ease-in-out infinite; }
.card-secondary { width: 220px; bottom: 40px; right: 0; animation: cardFloat2 7s ease-in-out infinite; }
.card-tertiary { width: 210px; top: 0; right: 20px; animation: cardFloat3 5s ease-in-out infinite; }
.card-icon { width: 48px; height: 48px; border-radius: 12px; display: flex; align-items: center; justify-content: center; font-size: 22px; color: #fff; flex-shrink: 0; }
.ai-icon { background: linear-gradient(135deg, #6c5ce7, #a29bfe); }
.med-icon { background: linear-gradient(135deg, #0a5c8a, #1a8fc0); }
.check-icon { background: linear-gradient(135deg, #00c9a7, #00b894); }
.card-body h3 { font-size: 15px; font-weight: 700; color: #fff; margin-bottom: 4px; }
.card-body p, .progress-label { font-size: 12px; color: rgba(255,255,255,.58); }
.card-progress { width: 100%; margin-top: 16px; }
.progress-label { display: flex; justify-content: space-between; margin-bottom: 8px; }
.pulse-ring { position: absolute; bottom: 60px; left: 60px; width: 80px; height: 80px; border: 2px solid rgba(0,201,167,.4); border-radius: 50%; animation: pulseRing 2.5s ease-out infinite; }
.scroll-hint { position: absolute; bottom: 40px; left: 50%; transform: translateX(-50%); display: flex; flex-direction: column; align-items: center; gap: 6px; color: rgba(255,255,255,.42); font-size: 11px; cursor: pointer; z-index: 2; letter-spacing: 2px; }
@keyframes orbFloat { 50% { transform: translateY(-16px) scale(1.04); } }
@keyframes particleFly { 0% { transform: translateY(0) scale(1); opacity: 0; } 10% { opacity: 1; } 100% { transform: translateY(-120px) scale(0); opacity: 0; } }
@keyframes cardFloat1 { 50% { transform: translateY(-12px); } }
@keyframes cardFloat2 { 50% { transform: translateY(-8px); } }
@keyframes cardFloat3 { 50% { transform: translateY(-15px); } }
@keyframes pulseRing { 0% { transform: scale(.8); opacity: 1; } 100% { transform: scale(2.5); opacity: 0; } }
@media (max-width: 1024px) { .hero-content { flex-direction: column; text-align: center; } .hero-desc { margin: 0 auto 36px; } .hero-actions { justify-content: center; } .hero-right { flex: 0 0 auto; width: 100%; max-width: 440px; } }
@media (max-width: 768px) { .hero-title { font-size: 38px; } }
</style>
